
// note 
// npm install react-slick
// npm install slick-carousel
// https://github.com/akiran/react-slick

/**
  use 

  import SimpleSlider from './components/SimpleSlider/SimpleSlider';
  
 <SimpleSlider settings={customSliderSettings}>
      <div><h3>Hey Man 1</h3></div>
      <div><h3>Hey Man 2</h3></div>
      <div><h3>Hey Man 3</h3></div>
      <div><h3>Hey Man 4 </h3></div>
      <div><h3>Hey Man 5 </h3></div>
      <div><h3>Hey Man  6 </h3></div>
       </SimpleSlider>
*/
import React, { Component } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SimpleSlider.css";




class SimpleSlider extends Component {
  	
  constructor(props){
    super(props);
  	this.settings = {
      accessibility :false, 
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      ...this.props.settings

    };
  }

  render() {


   

    return (
      <div className="Slider-wrapper">
      		 <Slider {...this.settings}  >
           {this.props.children}
          </Slider>
      </div>
    );
  }
}

export default SimpleSlider;



// WEBPACK FOOTER //
// ./src/Components/SimpleSlider/SimpleSlider.js